/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Role/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function Role({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/AddPersonRelation/Content/CopyRelationships/Content/Relationships/Content/CopyRelationshipItem/Role",
  onChange,
  isInvalid
  
}) {
let optionsRolesValueData = fromData.useDataValue({ viewPath,
context: 'options',
path: 'roles',
})
let relationshipRoleValueData = fromData.useDataValue({ viewPath,
context: 'relationship',
path: 'role',
})
let relationshipRoleIsValidData = fromData.useDataIsValid({ viewPath,
context: 'relationship',
path: 'role',
validate: fromValidate.text,
required: true,
})
let relationshipRoleChangeData = fromData.useDataChange({ viewPath,
context: 'relationship',
path: 'role',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginTop={0}
 marginLeft={dtSpaceS}
 data="options.roles"
 from={optionsRolesValueData}
 data="relationship.role"
 value={relationshipRoleValueData}
 onChange={relationshipRoleChangeData}
 validate="/Data/validate.js text"
 invalid={!relationshipRoleIsValidData}
 required={true}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}